import { createTheme } from '@material-ui/core/styles';

const AqInsightTheme = createTheme({
  palette: {
    primary: {
      main: '#005f9e'
    },
    secondary: {
      main: '#7f8080'
    }
  },
  overrides: {
    MuiAlert: {
      message: {
        flexGrow: 1
      }
    },
    MuiSelect: {
      icon: {
        color: '#fff'
      }
    }
  }
});

export default AqInsightTheme;
